import { render, staticRenderFns } from "./sso_return.vue?vue&type=template&id=6e267ccc&"
import script from "./sso_return.vue?vue&type=script&lang=js&"
export * from "./sso_return.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports